module.exports = __webpack_public_path__ + "static/Заявление_на_закрытие_карточного_счета-69f9562e6a5145a5d5aab9dce9730b03.pdf";